<script setup lang="ts">
import type { TpgClickEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarListItemProps {
  selected?: boolean;
  currentIndicator?: boolean;
  readOnly?: boolean;
  primaryLabel?: string;
  secondaryLabel?: string;
  heading?: string;
  subtitle?: string;
  leadingIconTemplate?: IconConstant | '';
}

interface GrammarListItemSlots {
  'header-leading-buttons'?: Slot;
  'header-trailing-buttons'?: Slot;
  'header-stuff'?: Slot;
  'list-item-row-1'?: Slot;
  'list-item-row-2'?: Slot;
}

const props = withDefaults(defineProps<GrammarListItemProps>(), {
  selected: false,
  currentIndicator: false,
  readOnly: false,
  primaryLabel: '',
  secondaryLabel: '',
  heading: '',
  subtitle: '',
  leadingIconTemplate: '',
});

const emit = defineEmits<{
  click: [event: TpgClickEvent];
}>();
const slots = defineSlots<GrammarListItemSlots>();

function onClick(event: TpgClickEvent) {
  emit('click', event);
}
</script>

<template>
  <tpg-list-item
    v-bind="props"
    @tpg-click="onClick"
  >
    <div
      v-if="slots['header-leading-buttons']"
      slot="header-leading-buttons"
      class="flex items-center min-w-0"
    >
      <slot name="header-leading-buttons" />
    </div>

    <div
      v-if="slots['header-stuff']"
      slot="header-stuff"
    >
      <slot name="header-stuff" />
    </div>

    <div
      v-if="slots['header-trailing-buttons']"
      slot="header-trailing-buttons"
      class="flex items-center min-w-0"
    >
      <slot name="header-trailing-buttons" />
    </div>

    <div
      v-if="slots['list-item-row-1']"
      slot="list-item-row-1"
    >
      <slot name="list-item-row-1" />
    </div>

    <div
      v-if="slots['list-item-row-2']"
      slot="list-item-row-2"
    >
      <slot name="list-item-row-2" />
    </div>
  </tpg-list-item>
</template>
